/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventlocationnotfound3Inputs */

const en_eventlocationnotfound3 = /** @type {(inputs: Eventlocationnotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue not found. Please enter it or pick your place.`)
};

const de_eventlocationnotfound3 = /** @type {(inputs: Eventlocationnotfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort nicht gefunden, bitte eintragen oder deinen Ort wählen.`)
};

/**
* | output |
* | --- |
* | "Venue not found. Please enter it or pick your place." |
*
* @param {Eventlocationnotfound3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventlocationnotfound3 = /** @type {((inputs?: Eventlocationnotfound3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventlocationnotfound3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventlocationnotfound3(inputs)
	return de_eventlocationnotfound3(inputs)
});
export { eventlocationnotfound3 as "eventLocationNotFound" }